import type { TriggerJobResponseAction } from './triggerJob.action';
import type { UploadFileResponseAction } from './uploadFile.action';
import type { GetJobsResponseAction } from 'client/js/redux/domains/FileIngestor/actions/getJobs.action';
import type { GetJobByIdResponseAction, GetJobByIdRequestAction } from './getJobById';
import type { ClearJobDetailsAction } from './clearJobDetails';

export * from './triggerJob.action';
export * from './uploadFile.action';
export * from './getJobs.action';
export * from './getJobById';

export type FileIngestorAction =
  | TriggerJobResponseAction
  | UploadFileResponseAction
  | GetJobsResponseAction
  | GetJobByIdRequestAction
  | ClearJobDetailsAction
  | GetJobByIdResponseAction;
